<template>
    <svg class="icon" :class="iconClass" aria-hidden="true">
        <use :href="'#icon-' + symbol"></use>
    </svg>
</template>

<script lang="ts" setup>
import { computed, PropType } from "vue";

const props = defineProps({
    symbol: String,
    size: String as PropType<'xs'|'s'|'default'|'m'|'l'|'xl'|'xxl'|'3xl'|'4xl'|'5xl'|'6xl'>
})

const iconClass = computed(() => {
    const classList: string[] = [];
    if (props.size) {
        classList.push('icon-' + props.size);
    }
    return classList.join(' ');
})
</script>
